module.exports = __webpack_public_path__ + "img/image4.a88d5f26.png";